import React from 'react';
import { Row } from '../components/Layout';

interface StatsPageProps {
  onBack: () => void;
}

const StatsPage: React.FC<StatsPageProps> = ({ onBack }) => {
  const metrics = [
    { label: 'Toplam Süre', value: '42s 15d', icon: '⏱️', color: 'var(--cyan)' },
    { label: 'Kazanılan Elmas', value: '14.5K', icon: '💎', color: 'var(--coral)' },
    { label: 'Toplam İzlenme', value: '8.2K', icon: '👀', color: 'var(--purple)' },
    { label: 'Yeni Takipçi', value: '+340', icon: '👥', color: 'var(--green)' },
  ];

  const recentStreams = [
    { date: 'Bugün, 14:30', duration: '2s 10d', viewers: 450, diamonds: 1200 },
    { date: 'Dün, 20:00', duration: '1s 45d', viewers: 320, diamonds: 800 },
    { date: '12 Nis, 18:15', duration: '3s 05d', viewers: 890, diamonds: 2500 },
    { date: '10 Nis, 21:00', duration: '1s 30d', viewers: 210, diamonds: 450 },
  ];

  return (
    <div style={{
      width: '100%', height: '100%',
      background: 'linear-gradient(160deg, #12121c, #0e0e18)',
      display: 'flex', flexDirection: 'column',
      position: 'relative', overflow: 'hidden'
    }}>
      {/* Header */}
      <div style={{
        padding: '50px 20px 20px',
        background: 'rgba(255,255,255,.02)',
        borderBottom: '1px solid var(--border)',
        display: 'flex', alignItems: 'center', gap: 15,
        position: 'relative', zIndex: 10
      }}>
        <button onClick={onBack} className="icon-btn" style={{ background: 'rgba(255,255,255,.05)' }}>
          ←
        </button>
        <h2 className="syne" style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>Yayın İstatistikleri</h2>
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: '20px', paddingBottom: '90px' }}>
        {/* Metrik Kartları */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 24 }}>
          {metrics.map((m, i) => (
            <div key={i} style={{
              background: 'rgba(255,255,255,.03)',
              border: '1px solid var(--border)',
              borderRadius: 16, padding: '16px',
              position: 'relative', overflow: 'hidden'
            }}>
              <div style={{
                position: 'absolute', top: -20, right: -20,
                width: 60, height: 60, background: m.color,
                filter: 'blur(30px)', opacity: 0.15
              }} />
              <div style={{ fontSize: 24, marginBottom: 8 }}>{m.icon}</div>
              <div className="syne" style={{ fontSize: 20, fontWeight: 800, color: m.color, marginBottom: 4 }}>
                {m.value}
              </div>
              <div style={{ fontSize: 12, color: 'var(--muted)', fontWeight: 500 }}>
                {m.label}
              </div>
            </div>
          ))}
        </div>

        {/* Grafik Alanı (Mock) */}
        <div style={{
          background: 'rgba(255,255,255,.03)',
          border: '1px solid var(--border)',
          borderRadius: 16, padding: '20px', marginBottom: 24
        }}>
          <h3 className="syne" style={{ margin: '0 0 16px 0', fontSize: 16, color: 'var(--text)' }}>Haftalık Etkileşim</h3>
          <div style={{ height: 160, position: 'relative', display: 'flex', alignItems: 'flex-end', gap: '8%', padding: '10px 0' }}>
            {/* Sahte CSS Grafik çubukları */}
            {[40, 65, 30, 80, 50, 90, 70].map((h, i) => (
              <div key={i} style={{
                flex: 1, height: `${h}%`,
                background: i === 5 ? 'var(--coral)' : 'rgba(255,138,61,0.3)',
                borderRadius: '4px 4px 0 0',
                position: 'relative'
              }}>
                {i === 5 && (
                  <div style={{
                    position: 'absolute', top: -25, left: '50%', transform: 'translateX(-50%)',
                    background: 'var(--coral)', color: '#fff', fontSize: 10,
                    padding: '2px 6px', borderRadius: 4, fontWeight: 'bold'
                  }}>
                    Max
                  </div>
                )}
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10, color: 'var(--muted)', fontSize: 11 }}>
            <span>Pzt</span><span>Sal</span><span>Çar</span><span>Per</span><span>Cum</span><span>Cmt</span><span>Paz</span>
          </div>
        </div>

        {/* Son Yayınlar */}
        <h3 className="syne" style={{ margin: '0 0 16px 0', fontSize: 16, color: 'var(--text)' }}>Son Yayınlar</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {recentStreams.map((s, i) => (
            <div key={i} style={{
              background: 'rgba(255,255,255,.02)',
              border: '1px solid rgba(255,255,255,.05)',
              borderRadius: 12, padding: '14px',
              display: 'flex', justifyContent: 'space-between', alignItems: 'center'
            }}>
              <div>
                <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 4 }}>{s.date}</div>
                <div style={{ fontSize: 12, color: 'var(--muted)' }}>Süre: {s.duration}</div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: 13, color: 'var(--cyan)', fontWeight: 600, marginBottom: 2 }}>
                  💎 {s.diamonds}
                </div>
                <div style={{ fontSize: 12, color: 'var(--muted)' }}>
                  👁️ {s.viewers} izleyici
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatsPage;
